import domReady from '../../plugins/domready.js'

domReady(() => {
	if (document.querySelectorAll('.brandstories-display').length > 0) {
		let _ = import(
			"./brandstories.js"
		);
	}
});
